import { useCallback, useEffect, useState } from "react"
import useApi from "./useApi.js"

export default function useExperiments() {
  const api = useApi()
  const [state, setState] = useState({ status: "loading", data: [], error: null })

  const refresh = useCallback(async () => {
    try {
      const data = await api.get("/api/v1/shop/experiments")
      setState({ status: "loaded", data: Array.isArray(data) ? data : [], error: null })
    } catch (err) {
      setState({ status: "error", data: [], error: err.message })
    }
  }, [ api ])

  useEffect(() => { refresh() }, [ refresh ])

  return { ...state, refresh }
}
